<template>
  <el-card class="cc-handle-card soft-phone-card">
    <div class="cc-flex-space-betwenn">
      <div>
        <Phone></Phone>
      </div>
      <div class="cc-order-close"><el-button size="mini" @click="close" type="danger">关闭弹屏</el-button></div>
    </div>
    <div class="cc-order-handle">
      <el-tabs type="card" v-model="orderType" @tab-click="handleType">
        <el-tab-pane label="创建工单" name="order">
          <div class="cc-template cc-order-template">
            <div class="cc-template-lable">选择模板</div>
            <div v-for="item in orderTemplate" :key="item.formId" class="cc-template-item"
              :class="item.formId == selectTemplateId ? 'cc-template-item-default' : ''" @click="selectTemplate(item)">
              <i class="el-icon-s-order"></i>{{ item.formName }}
            </div>
          </div>
          <el-form label-width="100px" size="mini" v-if="selectTemplateId != 0">
            <div class="cc-order-template-main">
              <div class="cc-order-template-left cc-scroll">
                <el-form-item v-for="(item, index) in clueInputs" :key="item.layout + index" :label="item.label">
                  <el-input v-if="item.tag == 'el-input'" v-model="item.defaultValue" :type="item.type"></el-input>
                  <el-radio-group v-if="item.tag == 'el-radio-group'" v-model="item.defaultValue">
                    <el-radio v-for="(item1, index) in item.options" :key="item1.value + index"
                      :label="item1.value"></el-radio>
                  </el-radio-group>
                  <el-select v-if="item.tag == 'el-select'" v-model="item.defaultValue" placeholder="请选择">
                    <el-option v-for="item2 in item.options" :key="item2.value" :label="item2.label"
                      :value="item2.value">
                    </el-option>
                  </el-select>
                  <el-checkbox-group v-if="item.tag == 'el-checkbox-group'" v-model="item.defaultValue">
                    <el-checkbox v-for="(city, index) in item.options" :key="city.value + index"
                      :label="city.value"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
              <div class="cc-order-template-right">
                <el-form-item label="完结" prop="orderStatus">
                  <el-radio-group v-model="orderForm.orderStatus">
                    <el-radio label="0" border>否</el-radio>
                    <el-radio label="1" border>是</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="派发" prop="orderDistribute" v-if="orderForm.orderStatus == '0'">
                  <el-radio-group v-model="orderForm.orderDistribute">
                    <el-radio label="0" border style="margin-right: 0px;">否</el-radio>
                    <el-radio label="1" border>是</el-radio>
                  </el-radio-group>
                  <el-select clearable v-model="orderForm.groupId" placeholder="请选择技能组" @change="onGroupId"
                    v-if="orderForm.orderDistribute == '1'" style="margin-left: 5px; width: 180px;">
                    <el-option v-for="item in groupList" :key="item.id" :label="item.var" :value="item.id">
                    </el-option>
                  </el-select>
                  <el-select clearable v-model="orderForm.orderHandler" placeholder="请选择坐席"
                    v-if="orderForm.orderDistribute == '1' && orderForm.groupId !== ''"
                    style="margin-left: 5px; width: 180px;">
                    <el-option v-for="item in orderHandlerList" :key="item.userId" :label="item.personName"
                      :value="item.personName" :disabled="item.personName == currentHandle">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="comment" v-if="orderForm.orderDistribute == '1'">
                  <el-input type="textarea" v-model="orderForm.comment" placeholder="请输入工单备注"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="cc-order-template-bottom">
              <el-button size="mini" type="primary" @click="createOrder('ruleForm')">创建</el-button>
              <el-button size="mini" @click="setDefaultTemplate">取消</el-button>
            </div>
          </el-form>
          <div class="cc-template-hint" v-else>
            <i class="el-icon-warning"></i>未设置默认模板,创建工单时需手动选择模板
          </div>
        </el-tab-pane>
        <el-tab-pane label="工单记录" name="history">
          <div class="cc-order-history">
            <div class="cc-history-left">
              <el-table :data="orderList" height="calc(100vh - 220px)" highlight-current-row @row-click="orderDispose"
                ref="Table">
                <el-table-column label="模板" align="left" prop="formName" show-overflow-tooltip />
                <el-table-column label="编号" align="left" prop="orderNumber">
                  <template slot-scope="scope">
                    <span>{{ scope.row.orderNumber }}
                      <el-badge v-if="scope.row.orderUrge !== 0" :value="scope.row.orderUrge" class="item"></el-badge>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="处理人" align="center" prop="orderHandle" width="120px" />
                <el-table-column label="完结" align="center" prop="orderStatus" width="80px">
                  <template slot-scope="scope">
                    <el-tag effect="dark" type="success" v-if="scope.row.orderStatus == '1'">是</el-tag>
                    <el-tag effect="dark" type="info" v-else>否</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="时间" align="center" width="180px" prop="createTime" />
              </el-table>
            </div>
            <div class="cc-history-right cc-handle-scrollbar" v-if="rowData != null">
              <el-tabs type="card" v-model="Type">
                <el-tab-pane label="工单信息" name="order" class="mt-15">
                  <div class="cc-history-info cc-scroll cc-disabled">
                    <el-form label-width="80px" size="mini">
                      <el-form-item v-for="(item, index) in clueInputs" :key="item.layout + index" :label="item.label">
                        <el-input v-if="item.tag == 'el-input'" v-model="item.defaultValue" :type="item.type"
                          disabled></el-input>
                        <el-radio-group v-if="item.tag == 'el-radio-group'" v-model="item.defaultValue" disabled>
                          <el-radio v-for="(item1, index) in item.options" :key="item1.value + index"
                            :label="item1.value"></el-radio>
                        </el-radio-group>
                        <el-select v-if="item.tag == 'el-select'" v-model="item.defaultValue" placeholder="请选择"
                          disabled>
                          <el-option v-for="item2 in item.options" :key="item2.value" :label="item2.label"
                            :value="item2.value" />
                        </el-select>
                        <el-checkbox-group v-if="item.tag == 'el-checkbox-group'" v-model="item.defaultValue" disabled>
                          <el-checkbox v-for="(city, index) in item.options" :key="city.value + index"
                            :label="city.value"></el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-form>
                  </div>
                  <el-form label-width="80px" size="mini">
                    <el-form-item label="本次处理">
                      <el-radio-group v-model="historyHandleType">
                        <el-radio v-if="currentHandle != rowData.orderHandle" label="1" border
                          style="margin-right: 0px;">加急</el-radio>
                        <el-radio label="2" border style="margin-right: 0px;">完结</el-radio>
                        <el-radio v-if="currentHandle == rowData.orderHandle" label="3" border
                          style="margin-right: 0px;">派发</el-radio>
                      </el-radio-group>
                      <el-select clearable v-model="updateForm.groupId" placeholder="请选择技能组" @change="onGroupId"
                        v-if="historyHandleType == '3'" style="margin-left: 5px; width: 150px;">
                        <el-option v-for="item in groupList" :key="item.id" :label="item.var" :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select clearable v-model="updateForm.orderHandler" placeholder="请选择坐席"
                        v-if="historyHandleType == '3' && updateForm.groupId != null"
                        style="margin-left: 5px; width: 150px;">
                        <el-option v-for="item in orderHandlerList" :key="item.userId" :label="item.personName"
                          :value="item.personName" :disabled="item.personName == currentHandle">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="备注" v-if="historyHandleType != '1' && historyHandleType != null">
                      <el-input type="textarea" v-model="updateForm.comment" placeholder="请输入工单备注"></el-input>
                    </el-form-item>
                  </el-form>
                </el-tab-pane>
                <el-tab-pane label="跟踪记录" name="track" class="mt-15">
                  <el-empty v-if="timeList.length == 0" description="暂无跟踪记录"></el-empty>
                  <el-timeline v-else>
                    <el-timeline-item v-for="(item, index) in timeList" :key="index" :timestamp="item.createTime"
                      placement="top">
                      <div class="cc-timeline-time">
                        <div class="cc-timeline-time-top">
                          <div class="cc-timeline-time-label" v-if="item.operateType == 1">{{ item.operatorUser
                            }}将工单派发至{{
        item.holdUser }}</div>
                          <div class="cc-timeline-time-label" v-if="item.operateType == 2">{{ item.operatorUser }}代理完成{{
        item.holdUser }}的工单</div>
                          <div class="cc-timeline-time-label" v-if="item.operateType == 3">{{ item.operatorUser }}加急一次{{
        item.holdUser }}的工单</div>
                          <el-tag effect="dark" type="success" v-if="item.orderStatus == 1">已完结</el-tag>
                          <el-tag effect="dark" type="danger" v-else>未完结</el-tag>
                        </div>
                        <div class="cc-timeline-time-label">备注: <span>{{ item.comment }}</span></div>
                      </div>
                    </el-timeline-item>
                  </el-timeline>
                </el-tab-pane>
              </el-tabs>
              <div class="cc-order-history-bottom">
                <el-button size="mini" type="primary" @click="updateOrder()" v-if="Type == 'order'">确定</el-button>
                <el-button size="mini" @click="goBack" v-if="Type == 'track'">取消</el-button>
              </div>
            </div>
            <div class="cc-history-right cc-hint" v-else>
              <i class="el-icon-warning"></i>请从工单列表中选择要处理的工单
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="留资记录" name="record">
          <el-table :data="tableData" style="width: 100%; margin-top: 5px;" :height="table3">
            <el-table-column prop="batchName" label="批次名称" align="center" width="180px" />
            <el-table-column prop="phone" label="手机号" align="center" width="180px" />
            <el-table-column prop="userName" label="外呼坐席" align="center" />
            <el-table-column align="center" v-for="(item, index) in tableTitle" :key="index" :label="item.label"
              :prop="'callFormInfos.v' + (index + 1) + ''" :formatter="item.formatter" show-overflow-tooltip
              width="150px">
            </el-table-column>
            <el-table-column prop="saveTime" width="180" label="创建时间" align="center" />
          </el-table>
          <pagination v-show="total > 0" :pager-count="5" :total="total" :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize" @pagination="getList" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-card>
</template>

<script>
import { callSelection, selGroupList, groupUsers } from "../../api/index"
import { workorderSync, addWorkOrder, putworkOrder, timeLine } from "../../api/sip/work-order"
import { callForm, callResultList } from "../../api/sip/build"
import Cookies from "js-cookie";
import Phone from "../Phone"
export default {
  components: {
    Phone,
  },
  data () {
    return {
      orderType: "order",
      orderTemplate: [], //工单模板
      selectTemplateId: 0, //选中的模板Id、
      orderForm: {
        orderStatus: "0",
        orderDistribute: "0"
      },
      clueInputs: [],
      orderList: [],//来电历史记录
      currentHandle: Cookies.get("userName"),
      rowData: null,
      updateForm: {
        orderId: 0,
        orderUrge: 0,
        orderStatus: '0',
        groupId: null,
        comment: ''
      },
      historyHandleType: null,
      groupList: [],  //技能组
      orderHandlerList: [],//坐席
      userName: Cookies.get("userName"),
      Type: 'order',
      timeList: [],
      callformList: [], //留资模板
      onCallId: 0,//留资id
      tableTitle: [], //留资表头
      tableData: [], //留资数据
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        phone: this.$store.state.phone.callInfo.showCallee,
      },
      total: 0,
    }
  },
  created () {
    this.getGroup()
    this.getOrderTemplate();
    this.getForm();
  },
  methods: {
    getForm () {
      callForm('2').then(res => {
        this.callformList = res.data
        if (this.callformList.length !== 0) {
          this.onCallId = this.callformList[0].formId || null
          this.tableTitle = JSON.parse(this.callformList[0].formConfig)
        }
      })
    },
    getList () {
      this.$set(this.queryParams, 'phone', this.$store.state.phone.callInfo.showCallee)
      callResultList(this.onCallId, this.queryParams).then(res => {
        this.tableData = res.rows
        this.total = res.total
      })
    },
    getOrderTemplate () {//工单模板
      callSelection('1').then(res => {
        this.orderTemplate = res.data
        this.setDefaultTemplate();
      })
    },
    //选项卡切换
    handleType (tab, event) {
      if (tab.name == "history") {
        this.getHistoryList();
        this.clueInputs = [];
      } else if (tab.name == "record") {
        this.getList()
      }
      else {
        this.setUpdateForm();
        this.clearTemplateContent();
        this.setDefaultTemplate();
      }
    },
    //选中模板
    selectTemplate (val) {
      this.selectTemplateId = val.formId
      this.clueInputs = JSON.parse(val.formConfig)
      this.reset()
    },
    //清空
    reset () {
      this.orderForm = {
        orderStatus: '0',
        orderDistribute: '0',
        groupId: null,
        orderHandler: null,
        comment: null,
      };
      this.resetForm("form");
    },
    setDefaultTemplate () {
      this.selectTemplateId = 0;
      if (this.orderTemplate && this.orderTemplate.length > 0) {
        const firstTemplate = this.orderTemplate[0];
        if (firstTemplate.defaultFlag === 1) {
          this.selectTemplateId = this.orderTemplate[0].formId;
        }
        this.clueInputs = JSON.parse(this.orderTemplate[0].formConfig)
      }
    },
    setUpdateForm () {
      this.historyHandleType = null;
      this.rowData = null;
      this.updateForm = {};
    },
    clearTemplateContent () {
      for (let i = 0; i < this.clueInputs.length; i++) {
        if (this.clueInputs[i].tag == "el-checkbox-group") {
          this.clueInputs[i].defaultValue = []
        } else {
          this.clueInputs[i].defaultValue = null
        }
      }
    },
    //创建工单
    createOrder () {
      let callFormInfo = {};
      for (let i = 0; i < this.clueInputs.length; i++) {
        let fieldName = this.clueInputs[i].vModel;
        callFormInfo[fieldName] = this.clueInputs[i].tag == "el-checkbox-group" ? this.clueInputs[i].defaultValue.join(",") : this.clueInputs[i].defaultValue;
      }
      let orderTemplateForm = {
        orderFormJson: callFormInfo,
        formId: this.selectTemplateId,
        callerPhone: this.$store.state.phone.callInfo.callee,
        ...this.orderForm
      }
      addWorkOrder(orderTemplateForm).then(res => {
        this.clueInputs = [];
        this.getHistoryList();
        this.$notify({
          title: res.msg,
          type: 'success',
          duration: 1000
        });
      })
      this.$store.commit('SET_ORDER', false)
    },

    //工单记录
    getHistoryList () {
      workorderSync(this.$store.state.phone.callInfo.callee).then(res => {
        this.orderList = res.data
      })
    },

    //技能组
    getGroup () {
      selGroupList().then((res) => {
        this.groupList = res.data
      })
    },

    //技能组事件
    onGroupId (groupId) {
      groupUsers({ groupId: groupId }).then(res => {
        this.orderHandlerList = res.data
      })
    },
    //关闭弹窗
    close () {
      this.$store.commit('SET_ORDER', false)
    },

    updateOrder () {
      this.updateForm.orderId = this.rowData.orderId;
      if (this.historyHandleType == '1') {
        this.updateForm.orderUrge = 1;
      } else if (this.historyHandleType == '2') {
        this.updateForm.orderStatus = '1';
        this.updateForm.orderDistribute = '0'
      } else {
        this.updateForm.orderStatus = '0';
        this.updateForm.orderDistribute = '1'
      }
      putworkOrder(this.updateForm).then(res => {
        this.setUpdateForm();
        this.getHistoryList();
        this.$notify({
          title: res.msg,
          type: 'success',
          duration: 1000
        });
      })
    },
    //处理
    orderDispose (row) {
      this.historyHandleType = null;
      this.Type = 'order'
      this.rowData = row
      this.clueInputs = row.formJson
      if (Object.keys(row.orderFormJson).length > 0) {
        this.callFormInfo = row.orderFormJson
        for (let i = 0; i < this.clueInputs.length; i++) {
          if (this.clueInputs[i].tag == "el-checkbox-group") {
            this.clueInputs[i].defaultValue = this.callFormInfo[this.clueInputs[i].vModel].split(",");
          } else {
            this.clueInputs[i].defaultValue = this.callFormInfo[this.clueInputs[i].vModel];
          }
        }
      } else {
        this.clearTemplateContent();
      }
      //时间轴-跟踪记录
      timeLine(this.rowData.orderId).then(res => {
        this.timeList = res.data
      })
    },
    //关闭
    goBack () {
      this.rowData = null;
      this.$refs.Table.setCurrentRow();
    }
  }
}
</script>

<style lang="scss" scoped>
.cc-order-close {
  margin-top: 10px;
  margin-right: 10px;
}

.cc-order-template {
  margin-top: 15px;
  margin-left: 15px;

}

.cc-order-template-main {
  height: calc(100vh - 310px);
  display: flex;
  justify-content: space-between;
}

.cc-order-template-left {
  width: 50%;
  height: 100%;
  overflow: auto;
  padding-right: 30px;
  border-right: 1px solid #f0f0f0
}

.cc-order-template-right {
  width: 46%;
}

.cc-order-template-bottom {
  text-align: end;
  padding: 10px 0;
  border-top: 1px solid #f0f0f0
}

.cc-order-history {
  padding-top: 15px;
  display: flex;
  justify-content: space-between;
}

.cc-history-left {
  width: 50%;
  padding-right: 30px;
  border-right: 1px solid #f0f0f0
}

.cc-history-right {
  width: 45%;
  height: calc(100vh - 240px);
  overflow: auto;
}

.cc-history-info {
  max-height: 300px;
  overflow: auto;
  padding-bottom: 10px;
}

.cc-order-history-bottom {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>